import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/destyle.css';
import './assets/css/global.css';
import { ApiErrorProvider } from './errorHandling/context/ApiErrorContext';
import { startSentryTrackingError } from './errorHandling/sentryTracking';
import { ensureCsrfToken } from './utils/csrfToken';

startSentryTrackingError();
// Reactツリー外のため ErrorBoundary でキャッチできないので、Sentry通知に留めている。
// ここで取得できなかった場合、各リクエスト時に再取得するため問題ない。
ensureCsrfToken().catch((error) => {
  Sentry.captureException(error);
});

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ApiErrorProvider>
        <App />
      </ApiErrorProvider>
    </React.StrictMode>,
  );
}
